import styled from "styled-components";

export const StyledSelectWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  label {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .select-input {
    & > div:first-child {
      height: inherit;
      padding: 0px;
      margin: 0;
      padding-left: 6px;
      font-size: 14px;
    }
    input {
      border: 1px solid ${({ theme }) => theme.colors.skeletonPulse};
      border-radius: 8px;
      font-size: 14px;
      width: 100%;
      outline: none;
      box-sizing: border-box;
      height: 30px;
      &:focus {
        border: 1px solid ${({ theme }) => theme.colors.text};
      }
      &::placeholder {
        font-size: 12px;
      }
    }
  }
`;
